// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsSidebar-cls1_u2I","cls2":"ToolsSidebar-cls2_uHD ToolsSidebar-cls1_u2I"};